import React, { ReactNode, useContext } from 'react';
import { Navigate } from 'react-router-dom';
import { AuthContext } from '../context/AuthContext';

export default function ProtectedRoute({ children }: { children: ReactNode }) {
    const { user, initializing } = useContext(AuthContext);
    if (initializing) return null;
    if (!user) return <Navigate to="/" replace />;
    return <>{children}</>;
}
